import { Entity } from "../../Entity";
import { FactoryInterface } from "../../../Entity/FactoryInterface";
import FinancialStatementFactory from "../../Factories/FinancialStatementFactory";
import { FinancialStatementInterface } from "./FinancialStatementInterface";
import { FinancialStatementTypeInterface } from "./Type/FinancialStatementTypeInterface";
import { FinancialStatementStatusInterface } from "./Status/FinancialStatementStatusInterface";
import { CompanyInterface } from "../Company/CompanyInterface";

class FinancialStatement extends Entity implements FinancialStatementInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return FinancialStatementFactory;
  }

  get nameForUrl() {
    return "statement";
  }

  get id(): number {
    return this.data.id;
  }

  get carriedFromLastMonth(): number {
    return this.data.carriedFromLastMonth;
  }

  get carry(): number {
    return this.data.carry;
  }

  get companyId(): number {
    return this.data.companyId;
  }

  get company(): CompanyInterface {
    return this.relation("app.companies", this.data.companyId)[0];
  }

  get creationDate(): Date {
    return this.data.creationDate;
  }

  get statement(): object {
    return JSON.parse(this.data.data);
  }

  get payout(): number {
    return this.data.payout;
  }

  get period(): Date {
    return this.data.period;
  }

  get type(): FinancialStatementTypeInterface {
    return this.data.type;
  }

  get removable(): boolean {
    return this.data.removable;
  }

  get removed(): boolean {
    return this.data.removed;
  }

  get firstDate(): Date {
    return this.data.firstDate;
  }

  get lastDate(): Date {
    return this.data.lastDate;
  }

  get ownerId(): number {
    return this.data.ownerId;
  }

  get owner(): CompanyInterface {
    return this.relation("app.companies", this.data.ownerId)[0];
  }

  get periodId(): number {
    return this.data.periodId;
  }

  get balanceId(): number {
    return this.data.balanceId;
  }

  get balance(): object {
    return this.data.balance;
  }

  get status(): FinancialStatementStatusInterface {
    return this.data.status;
  }

  get isSent(): boolean {
    return this.data.isSent;
  }

  get isSnoozed(): boolean {
    return this.data.isSnoozed;
  }

  get actualPayoutChargeId(): number {
    return this.data.actualPayoutChargeId;
  }

  get readinessStatusId(): number {
    return this.data.readinessStatusId;
  }

  get hasMemos(): boolean {
    return this.data.hasMemos;
  }

  get result(): number {
    return this.data.result;
  }

  get updatedAt(): Date {
    return this.data.updatedAt;
  }

  get payoutSection(): any {
    return (Object.keys(this.data.data).length !== 0) ? this.data.data.payoutSection : null;
  }

  get locked(): Date {
    return this.data.locked;
  }
}

export { FinancialStatement };
